import type { SVGProps } from "react";

export function XMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.28033 5.71967C5.98744 5.42678 5.51256 5.42678 5.21967 5.71967C4.92678 6.01256 4.92678 6.48744 5.21967 6.78033L8.93934 10.5L5.21967 14.2197C4.92678 14.5126 4.92678 14.9874 5.21967 15.2803C5.51256 15.5732 5.98744 15.5732 6.28033 15.2803L10 11.5607L13.7197 15.2803C14.0126 15.5732 14.4874 15.5732 14.7803 15.2803C15.0732 14.9874 15.0732 14.5126 14.7803 14.2197L11.0607 10.5L14.7803 6.78033C15.0732 6.48744 15.0732 6.01256 14.7803 5.71967C14.4874 5.42678 14.0126 5.42678 13.7197 5.71967L10 9.43934L6.28033 5.71967Z"
        fill="#808080"
      />
    </svg>
  );
}
